import React from 'react';

import { InfoField } from '@occc/ui-design-system';
import { EarningMechanismVisitsFragment } from '@occc/graphql';

interface IVisitsProps {
  earningMechanism: EarningMechanismVisitsFragment;
}

export const Visits: React.FC<IVisitsProps> = ({ earningMechanism }) => {
  return <InfoField label='Visits' value={earningMechanism?.visitThreshold} />;
};
